import { render, staticRenderFns } from "./BackLink.vue?vue&type=template&id=0f1e00c8"
import script from "./BackLink.vue?vue&type=script&lang=js"
export * from "./BackLink.vue?vue&type=script&lang=js"
import style0 from "./BackLink.vue?vue&type=style&index=0&id=0f1e00c8&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f1e00c8')) {
      api.createRecord('0f1e00c8', component.options)
    } else {
      api.reload('0f1e00c8', component.options)
    }
    module.hot.accept("./BackLink.vue?vue&type=template&id=0f1e00c8", function () {
      api.rerender('0f1e00c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/Product/BackLink.vue"
export default component.exports